module.exports = __webpack_public_path__ + "static/media/btn-download-app.6cc827a0.png";